import React from 'react'
import { func, arrayOf, string } from 'prop-types'
import {
  Button,
  Modal,
  ModalContent,
  Dialog,
  Illustration
} from '@cobalt/cobalt-react-components'
import {
  RECOVERY_OTP_CONFIRM_TITLE,
  RECOVERY_OTP_CONFIRM_MESSAGE,
  RECOVERY_OTP_CONFIRM_CANCEL,
  RECOVERY_OTP_CONFIRM_CONTINUE
} from '../../constants/ui.labels'
import { ContentHeader } from '../../components'
import RecoveryOTPBox from '../RecoveryOTPBox/index'

const renderConfirm = (onDismiss, onConfirm) => (
  <React.Fragment>
    <Illustration name={Illustration.EXCLAMATION} />
    <ContentHeader
      title={RECOVERY_OTP_CONFIRM_TITLE}
      message={RECOVERY_OTP_CONFIRM_MESSAGE}
    />
    <Dialog.Actions>
      <Button basic secondary onClick={onDismiss}>
        {RECOVERY_OTP_CONFIRM_CANCEL}
      </Button>
      <Button basic primary onClick={onConfirm}>
        {RECOVERY_OTP_CONFIRM_CONTINUE}
      </Button>
    </Dialog.Actions>
  </React.Fragment>
)

const renderCodes = otpList => <RecoveryOTPBox otpList={otpList} />

const RecoveryOTPConfirm = ({ onDismiss, onConfirm, otpList = [] }) => (
  <Modal small dismissible onDismiss={onDismiss}>
    <ModalContent>
      <Dialog>
        <Dialog.Content>
          {otpList.length > 0
            ? renderCodes(otpList)
            : renderConfirm(onDismiss, onConfirm)}
        </Dialog.Content>
      </Dialog>
    </ModalContent>
  </Modal>
)

RecoveryOTPConfirm.propTypes = {
  onDismiss: func.isRequired,
  onConfirm: func.isRequired,
  otpList: arrayOf(string)
}

export default RecoveryOTPConfirm
